import DropdownDepth from "./DropdownDepth";
import Landschap from "./Landschap";
import BetrokkenPartijen from "./BetrokkenPartijen";

import * as d3 from "d3";
import { useEffect } from 'react';

function Filters({ data, setDepth, clickSelection, connectionChains,
  chainSelection, landschapOptions, partijenOptions, setLandschapOptions,
  setPartijenOptions }) {

  useEffect(() => {
    // d3.selectAll('.select__indicator, .select__indicators').style('opacity', 0);
    // d3.selectAll('.select__multi-value__remove').remove();
    // d3.selectAll('.basic-multi-select').style('pointer-events', 'none')
    //
    // d3.selectAll('.select__multi-value__label')
    //   .style('pointer-events', 'auto')
    //   .on('mouseover', hover)
    //   .on('mouseout', mouseout)
    //   .on('click', click);
    d3.selectAll('.select__clear-indicator svg')
      .style('fill', 'black')

  })

  const chainSelectionText = (chainSelection >= 0)
    ? 'Geselecteerde impact: ' + data.filter(d => +d.ID === chainSelection)[0]['oorzaakeffectimpact_kort']
    : 'Geen impact geselecteerd'
  return (
    <div className="Filters">
      <h3 className='filterTitle'>Filter iconen op basis van combinatie actoren en gebieden</h3>
      {/* <p>Filter de geselecteerde keten door actoren of landschapstypen te verwijderen of toe te voegen. De iconen die niet aan het filter voldoen verdwijnen</p> */}
      {/* <p className='keten_titel'><em>{chainSelectionText}</em></p> */}
      {/* <DropdownDepth setDepth={setDepth} /> */}

      <BetrokkenPartijen data={data} clickSelection={clickSelection}
        connectionChains={connectionChains} chainSelection={chainSelection}
        partijenOptions={partijenOptions} setPartijenOptions={setPartijenOptions} />
      <Landschap data={data} clickSelection={clickSelection}
        connectionChains={connectionChains} chainSelection={chainSelection}
        landschapOptions={landschapOptions} setLandschapOptions={setLandschapOptions} />

    </div>
  );
}

export default Filters;
